import { useEffect, useState } from 'react';
import { listJobReasonCodes, type JobReasonCode } from '../../reference-data/reference-data.api';

export type JobReasonCodeAction = 'hold' | 'cancel';

interface Loaded {
  action: JobReasonCodeAction;
  options: JobReasonCode[];
}

export type JobReasonCodeOptionsState = { status: 'loading'; options: [] } | { status: 'loaded'; options: JobReasonCode[] } | { status: 'error'; options: [] };

/** Active reason codes tagged for `action` (gitaumoses4/chukua#40), for `JobActionReasonModal`'s picker. Fetches only while the modal for that action is open. */
export function useJobReasonCodeOptions(action: JobReasonCodeAction | null): JobReasonCodeOptionsState {
  const [loaded, setLoaded] = useState<Loaded | null>(null);
  const [erroredAction, setErroredAction] = useState<JobReasonCodeAction | null>(null);

  useEffect(() => {
    if (!action) return;
    let cancelled = false;

    listJobReasonCodes()
      .then((codes) => {
        if (cancelled) return;
        const field = action === 'hold' ? 'appliesToHold' : 'appliesToCancel';
        setLoaded({ action, options: codes.filter((code) => code.isActive && code[field]) });
      })
      .catch(() => {
        if (!cancelled) setErroredAction(action);
      });

    return () => {
      cancelled = true;
    };
  }, [action]);

  if (!action) return { status: 'loading', options: [] };
  if (erroredAction === action) return { status: 'error', options: [] };
  if (loaded?.action === action) return { status: 'loaded', options: loaded.options };
  return { status: 'loading', options: [] };
}
